import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSelector } from 'react-redux'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import Button from '../../components/General/Button'
import InputNumber from '../../components/Inputs/InputNumber'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
import SelectOfCategories from '../../components/Inputs/SelectOfCategories'
import { RootState } from '../../redux/store'
import { formatPipe } from '../../utils/utils'

const ServicesForm: React.FC<IServicesFormProps> = ({ defaultValues, onCancel, onSubmit, useType }) => {
  const form = useForm({
    defaultValues: {
        price: 0,
        ...defaultValues
    }
  })

  const ivaType = [
    {
      value: 'GENERAL',
      text: 'General - 16%',
    },
    {
      value: 'REDUCED',
      text: 'Reducido - 8%',
    },
    {
      value: 'EXEMPT',
      text: 'Exento - 0%',
    },
  ]

  const currencies = useSelector((state: RootState) => state.curr.currencies)

  const [currenciesValues, setCurrenciesValues] = useState<
    { text: string; value: string }[]
  >([])

  const [selectedCurrency, setSelectedCurrency] = useState<any | null>(null)

  useEffect(() => {
    let filteredCurrencies = currencies.reduce((a, b: any) => {
      if (b?.id === '1' || b?.id === '2') {
        if (b?.id === '2') {
          return [...a, { text: 'BOLÍVAR (VES)', value: b?.id + '' }]
        } else {
          return [...a, { text: 'REF (USD)', value: b?.id + '' }]
        }
      }
      return a
    }, [] as any[])
    setCurrenciesValues(filteredCurrencies)
  }, [currencies])

  const getIvaType = () => {
    return ivaType.find((d) => d.value === defaultValues?.ivaType)
  }

  return (
    <Form form={form} onSubmit={(values) => onSubmit({...values, price: formatPipe(values.price, true)})} classes="gap-3">
      <h2 className="text-primary-900 font-bold dark:text-white mb-5 col-span-12">
        {useType === 'create' ? 'Añadir servicio' : 'Editar servicio'}
      </h2>

      <FormItem
        name="name"
        classes="col-span-6"
        rules={{ required: 'Es necesario un nombre' }}
      >
        <InputText label="Nombre" />
      </FormItem>

      <FormItem name="price" classes="col-span-6">
        {/* <InputText small label="Precio" maxLength={16} /> */}
        <InputNumber small label="Precio" addDecimals={true} />
      </FormItem>

      <FormItem
        name="ivaType"
        classes="col-span-6"
        defaultValue={getIvaType() || ivaType[0]}
      >
        {/* <InputText small label="Precio" maxLength={16} /> */}

        <Select
          options={ivaType}
          label="Tipo de iva"
          // setSelectedHelper={async (v) => {
          //   setTypeDocumentSelected(v)
          //   let value = await onCheckCb(
          //     useType,
          //     form.getValues().document.document,
          //     v.value,
          //     userConfig.rowsPerPage,
          //     '/thirdparty/provider?',
          //     'providers'
          //   )
          //   if (value) {
          //     form?.setError('document.document', {
          //       type: 'manual',
          //       message: 'Proveedor ya existe',
          //     })
          //   } else {
          //     form?.clearErrors('document.document')
          //   }
          // }}
        />
      </FormItem>

      <FormItem
        name="currency.id"
        classes="col-span-6"
        defaultValue={
          currenciesValues?.find(
            (currency) => currency.value === defaultValues?.currency?.id
          ) || currenciesValues[0]
        }
      >
        {/* <InputText small label="Unidad de medida" maxLength={80} /> */}
        <SelectOfCategories
          options={currenciesValues}
          label={`Moneda`}
          onChange={(values) => {
            setSelectedCurrency(
              currencies.find((currency) => currency.id === values?.value)
            )
          }}
        />
      </FormItem>

      <div className="col-start-4 col-span-9 flex space-x-2 px-1 mt-4 row-start-8 block lg:col-start-3">
        <Button
          type="outline"
          classes="w-1/2 mr-4"
          onClick={() => onCancel()}
          htmlType="button"
        >
          Cancelar
        </Button>

        <Button type="primary" classes="w-1/2 mr-4" htmlType="submit">
          {useType === 'create' ? 'Añadir' : 'Guardar cambios'}
        </Button>
      </div>

    </Form>
  )
}

interface IServicesFormProps {
  defaultValues: any
  onCancel: () => void
  onSubmit: (values : any) => void 
  useType: "edit" | "create"
}

export default ServicesForm
